import {
    LOAD_CITY_SELECT_OPTIONS,
} from '../actions/types';

export default function (state = [], action) {
    switch (action.type) {
        case LOAD_CITY_SELECT_OPTIONS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/app/reducers/city_options_reducer.js